import React, { useState, useEffect, useRef } from 'react';
import '../FadeInSectionDownToUp.css';

const FadeInSectionDownToUpDelay = ({ children, delay = '0ms' }) => {
    const [isVisible, setVisible] = useState(false);
    const domRef = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.unobserve(entry.target); // Only trigger once
                }
            });
        });

        const { current } = domRef;
        if (current) observer.observe(current);

        return () => {
            if (current) observer.unobserve(current);
        };
    }, []);

    return (
        <div
            className={`fade-in-section-down-to-up ${isVisible ? 'is-visible-down-to-up' : ''}`}
            ref={domRef}
            style={{
                transitionDelay: isVisible ? delay : '0ms',
            }}
        >
            {children}
        </div>
    );
};

export default FadeInSectionDownToUpDelay;
